import React, { useState } from 'react';
import { useWorkspace } from '../context/WorkspaceContext';
import WorkspaceBanner from '../components/WorkspaceBanner';
import CreateWorkspaceModal from '../components/CreateWorkspaceModal';

function Widget({ title, value }) {
  return (
    <div
      style={{
        backgroundColor: '#2e2e2e',
        borderRadius: '8px',
        padding: '24px',
        border: '1px solid rgba(57, 255, 20, 0.15)',
        borderLeft: '3px solid #39FF14',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.4), 0 0 30px rgba(57, 255, 20, 0.12), 0 0 60px rgba(57, 255, 20, 0.06)',
      }}
    >
      <div
        style={{
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 500,
          fontSize: '11px',
          color: '#888888',
          textTransform: 'uppercase',
          letterSpacing: '1.5px',
          marginBottom: '16px',
        }}
      >
        {title}
      </div>
      <div
        style={{
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 900,
          fontSize: '48px',
          color: '#39FF14',
          lineHeight: 1,
        }}
      >
        {value}
      </div>
      <div
        style={{
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 300,
          fontSize: '13px',
          color: '#565656',
          marginTop: '8px',
        }}
      >
        No data yet
      </div>
    </div>
  );
}

export default function Dashboard() {
  const { workspaces, isLoading } = useWorkspace();
  const [showCreateModal, setShowCreateModal] = useState(false);

  if (isLoading) {
    return (
      <div
        style={{
          backgroundColor: '#222222',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 300,
            fontSize: '16px',
            color: '#888888',
          }}
        >
          Loading...
        </span>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: '#222222',
        minHeight: '100vh',
        padding: '32px',
      }}
    >
      <h1
        style={{
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 700,
          fontSize: '24px',
          color: '#FFFFFF',
          marginBottom: '6px',
        }}
      >
        Dashboard
      </h1>
      <p
        style={{
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 300,
          fontSize: '18px',
          color: '#888888',
          marginBottom: '32px',
        }}
      >
        Welcome to Vance
      </p>

      {!isLoading && workspaces.length === 0 && (
        <WorkspaceBanner
          onCreateClick={() => setShowCreateModal(true)}
          onJoinClick={() => {}}
        />
      )}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '24px',
        }}
      >
        <Widget title="Active Events" value="—" />
        <Widget title="Team Members" value="—" />
        <Widget title="Venues" value="—" />
      </div>

      <CreateWorkspaceModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={() => setShowCreateModal(false)}
      />
    </div>
  );
}
